import { BASE_COLOR as BC } from 'shared/constants/colors';
import { css } from 'helpers';


// DOM attributes, not CSS styles
export const uneditable = {
  contentEditable: false,
  spellCheck: false,
}


// code mark
export const codeMark = css({
  fontSize: '15px',
  padding: '3px 2px 1px',
  color: '#DD4A68',  // One of prism color
  background: BC.nearWhite,
  borderRadius: '.125rem', // br1
});

// Tooltip
export const tooltipTiny = css({
  padding: '4px 8px !important',
  fontSize: '11px !important',
  fontWeight: 300,
  lineHeight: 1,
});

// Border Radius

export const firstLastChildBR2 = {
  '& > *:first-child': {
    borderRadius: '.25rem 0 0 .25rem',
  },
  '& > *:last-child': {
    borderRadius: '0 .25rem .25rem 0',
  },
};


// Movement
export const animateTranslateUp = {
  animation: 'translatePositionUp 200ms ease forwards',
};

export const animateTranslateUpLarge = {
  animation: 'translatePositionUpLarge 200ms ease forwards',
};

export const animateFadeInSlow = {
  animation: 'opacityFadeInFull 500ms ease forwards',
};


// SVG
export const svgFillCurrentColor = {
  '& svg': { fill: 'currentColor' }
};


// button
export const boxShadowRaisedButton = {
  boxShadow: '3px 3px 0px #ccc',
  '&:hover':    { boxShadow: '3px 3px 0px #aaa', },
  '&:disabled': { boxShadow: '3px 3px 0px #ccc !important', },
};


export const classes = {
  codeMark: css(codeMark),
  tooltipTiny: css(tooltipTiny),
  firstLastChildBR2: css(firstLastChildBR2),
  animateTranslateUp: css(animateTranslateUp),
  animateTranslateUpLarge: css(animateTranslateUpLarge),
  animateFadeInSlow: css(animateFadeInSlow),
  svgFillCurrentColor: css(svgFillCurrentColor),
  boxShadowRaisedButton: css(boxShadowRaisedButton),
};



// WEBPACK FOOTER //
// ./src/shared/styles/index.js